module.exports = __webpack_public_path__ + "assets/img/da40105453222fdcc1e18781a80f4c4d.png";